import React, { useState } from 'react';
import { Row, Col, InputGroup, FormControl, Accordion } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//icons
import { BiSearchAlt2 } from 'react-icons/bi';
import { MdPlace } from 'react-icons/md';
import { AiFillPhone, AiOutlineClockCircle } from 'react-icons/ai';
import { HiMail } from 'react-icons/hi';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//styles
import './availableLibraries.scss';

const AvailableLibraries = ({ showLibraries, closeOverlay, libraries }) => {
  const { t } = useTranslation(['libraries', 'backoffice']);
  const { assignedLibrary } = useAssignedLibrary();
  const [searchText, setSearchText] = useState('');
  const [activeAccordionKey, setActiveAccordionKey] = useState(null);
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const filteredLibraries = libraries.filter(library => {
    const searchLower = searchText.toLowerCase();
    return (
      library.name.toLowerCase().includes(searchLower) ||
      (library.direccion && library.direccion.toLowerCase().includes(searchLower))
    );
  })

  const handleCloseModal = () => {
    setActiveAccordionKey(null); 
    closeOverlay();    
  };

  const handleAccordionClick = (index) => {
    setActiveAccordionKey(activeAccordionKey === index ? null : index);
  };


  return (
    <Modal show={showLibraries} onHide={handleCloseModal} className="w-100 container-modal-available-book">
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>{t('bookstores')}</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pb-5">
        <Row className="pt-3 justify-content-center">
          <Col lg={12} >
            <InputGroup className="mb-3">
              <FormControl
                placeholder="Buscar por nombre, dirección"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={searchText}
                onChange={handleSearchChange}
              />
              <InputGroup.Text id="basic-addon2" className="bg-color-primary">
                <BiSearchAlt2 color="white" />
              </InputGroup.Text>
            </InputGroup>
          </Col>
          <Col lg={12}>
            {filteredLibraries.length > 0 && (
              <p className="border-available-book">
                {`${filteredLibraries.length === 1 ? t('oneBookstore') : t('haveFound')} 
                 ${filteredLibraries.length} ${filteredLibraries.length === 1 ? t('bookstore') : t('bookstores')}:`}
              </p>
            )}
          </Col>
        </Row>
        <Row className="librariesRow">
          {filteredLibraries.length === 0 ? (
            <Col lg={12} className="text-center py-4">
              <p className="text-muted">{t('noResults', { ns: 'backoffice' })}</p>
            </Col>
          ) : (
            filteredLibraries.map((el, index) => (
              <Col lg={12} key={index} className="container-items">
                <Row className="mx-2">
                  <Col>
                    <div className="font-weight-bolder  d-flex">
                      <MdPlace size="20" color="#0b5ed7" className="mx-2" />
                      <p className="text-name">{el.name}</p>
                    </div>
                    {el.direccion !== '' && (
                      <p>{el.direccion}</p>
                    )}
                  </Col>
                </Row>
                <Accordion
                  className="accordion-available-libraries"
                  activeKey={activeAccordionKey === index ? index.toString() : null}
                  onSelect={(key) => handleAccordionClick(Number(key))}
                >
                  <Accordion.Item
                    eventKey={index.toString()}
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <Accordion.Header
                        className={`${activeAccordionKey === index && 'active-accordion'} text-accordion mt-2`}
                        onClick={() => handleAccordionClick(index)}
                      >
                        {t('seeDetails')}
                      </Accordion.Header>
                      <div>
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/${assignedLibrary}/librerias/mapa`, {
                              state: {
                                selectedLibraryId: el.id,
                                selectedCoords: [el.latitude, el.longitude]
                              }
                            });
                          }}
                          className="text-accordion mt-2"
                        >
                          {t('seeMap')}
                        </Link>
                      </div>
                    </div>
                    <Accordion.Body>
                      <div className="d-flex gap-2">
                        <AiOutlineClockCircle className="mr-2" size="20" color="#0b5ed7" />
                        <p>{el.bussines_hours == null ? t('noData') : el.bussines_hours}</p>
                      </div>
                      <div className="d-flex gap-2">
                        <AiFillPhone className="mr-2" size="20" color="#0b5ed7" />
                        <p>{el.telefono == '' ? t('noData') : el.telefono}</p>
                      </div>
                      <div className="d-flex gap-2">
                        <HiMail size="20" color="#0b5ed7" />
                        <p>{el.email == '' ? t('noData') : el.email}</p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            ))
          )}
        </Row>
      </Modal.Body>
    </Modal>
  )
};

export default AvailableLibraries;
